import {
  DISABLE_VARIANTS_METAFIELDS_KEYS,
  PRODUCT_TYPES,
  ProductType,
} from '~/lib/constants'
import { collectionMetafields } from '~/lib/shopify/constants/metafields'
import { getProductFromShopify } from '~/lib/shopify/products'
import { metafieldsToObject } from '~/lib/shopify/utils/metafield-to-object'

import {
  UnlikelyProduct,
  UnlikelyVariant,
} from '@unlikelystudio/commerce-connector'

import { serializeShopifyStorefrontData } from '~/data/product-card-data'

export function filterVariantsByProductType(
  productType: ProductType,
  product: UnlikelyProduct,
): UnlikelyVariant[] {
  switch (productType) {
    case PRODUCT_TYPES.CANDLE:
      return product.variants.filter(
        (variant) =>
          variant?.[DISABLE_VARIANTS_METAFIELDS_KEYS[productType]]?.value !==
          'true',
      )
    default:
      return product.variants
  }
}

export function getByCharlotCustomizationIds(
  product: UnlikelyProduct,
  required,
) {
  const collections = product?.collections

  const customizationProducts = collections
    ?.filter(Boolean)
    ?.map((collection) => {
      const metafields = metafieldsToObject(
        collection.metafields,
        collectionMetafields,
      )
      return required
        ? metafields.requiredCustomizationItems
        : metafields.customizationItems
    })
    .filter(Boolean)
  let productsIds = null

  if (customizationProducts?.[0]) {
    productsIds = JSON.parse(customizationProducts?.[0])
  }

  return productsIds ?? []
}

export async function serializeCustomizationProducts(
  product,
  locale,
  required,
  ids,
) {
  const items =
    (await Promise.all(
      ids?.map(async (id) => {
        const shopifyProduct = await getProductFromShopify({
          locale,
          id,
          shouldFetchImages: false,
        })

        const variants = filterVariantsByProductType(
          product?.productType,
          shopifyProduct,
        )

        const serializedStorefrontData = await serializeShopifyStorefrontData(
          { ...shopifyProduct, variants },
          locale,
          true,
          product,
        )

        return { ...shopifyProduct, ...serializedStorefrontData, required }
      }) ?? [],
    )) ?? null

  return items
}
